module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode
    }
  }, [_c('p', [_vm._v("\n                While it appear as a modal for tablet and smartphones,\n                Dropdowns with "), _c('code', [_vm._v("hoverable")]), _vm._v(" prop won't change it's behavior to avoid any malfunction with hover.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExContentPosition,
      "code": _vm.ExContentPositionCode,
      "title": "Content and position",
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("custom")]), _vm._v(" prop to the item to add "), _c('strong', [_vm._v("any type of content")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v(":focusable=\"false\"")]), _vm._v(" prop to the "), _c('code', [_vm._v("dropdown-item")]), _vm._v(" if you dont want it to be focusable.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExHasLinkDisabled,
      "code": _vm.ExHasLinkDisabledCode,
      "title": "Links within",
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("Add the "), _c('code', [_vm._v("has-link")]), _vm._v(" prop to add a anchor tag / router-link, or "), _c('code', [_vm._v("disabled")]), _vm._v(" to disable an item.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomize,
      "code": _vm.ExCustomizeCode,
      "title": "Customizing with v-model"
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExCustomizeMultiple,
      "code": _vm.ExCustomizeMultipleCode,
      "title": "Multiple"
    }
  }, [_c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.7.6")])]), _vm._v(" "), _c('p', [_vm._v("Add the "), _c('code', [_vm._v("multiple")]), _vm._v(" prop to select one or more item.")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d8899e6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dropdown/Dropdown.vue
// module id = 1390
// module chunks = 11